import VueClipboard from "vue-clipboard2";
import Vue from "vue";
Vue.use(VueClipboard);